module.exports = __webpack_public_path__ + "fonts/Nunito-SemiBold.45db66b4.ttf";